exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exporbtn[data-v-be2d4088]{\n  float:right;\n  position: relative;\n}\n\n", ""]);

// exports
